import { tss } from 'tss-react/mui';

export const useNavAppBarStyles = tss.withName('NavAppBar').create(({ theme }) => ({
    appBar: {
        padding: "0.5% 0",
        boxShadow: "none",
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        maxWidth: "1640px",
        width: "100%",
        margin: "0 auto",
        paddingLeft: "16px",
        paddingRight: "16px",
        [theme.breakpoints.up('sm')]: {
            paddingLeft: "4%",
            paddingRight: "4%",
        },
    },
    brand: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        cursor: "pointer",
        textDecoration: "none",
        color: theme.palette.text.primary,
    },
    brandName: {
        fontFamily: "'Sentient', serif",
        fontWeight: 500,
        fontSize: "1.4rem",
        letterSpacing: "0.01em",
        color: theme.palette.text.primary,
    },
    actions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
    },
    mobileActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        [theme.breakpoints.up('lg')]: {
            display: "none",
        },
    },
    desktopActions: {
        display: "none",
        [theme.breakpoints.up('lg')]: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(4),
        },
    },
    desktopNav: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
    },
    menuIconButton: {
        color: theme.palette.text.primary,
    },
    cartButton: {
        color: theme.palette.text.primary,
    },
    languageSelect: {
        minWidth: 74,
    },
}));
